import secureLocalStorage from "react-secure-storage";

/**
 * @deprecated Use useGeneralSettings hook from GeneralSettingsContext instead
 * This function still works but won't react to changes. Only use for non-React contexts.
 */
export const getSettingValue = (settingKey) => {
    const value = secureLocalStorage.getItem("general_settings");
    if (Array.isArray(value)) {
        const setting = value.find(item => item.setting_key === settingKey);
        return setting ? setting.setting_value : null;
    } else {
        console.error('Data is not available in localStorage or not in the correct format (not an array)');
        return null;
    }
}
export function getIsPeople(): number {
  return Number(localStorage.getItem('is_people') || 0);
}

export function getCanGetAppointments(): number {
  return Number(localStorage.getItem('can_get_appointments') || 0);
}
export function getPeopleId(): number | null {
  const peopleId = localStorage.getItem("people_id");

  // Check if value exists and is a valid number
  if (!peopleId || isNaN(Number(peopleId))) {
    return null;
  }

  return parseInt(peopleId, 10);
}